import React from 'react';
import { withRouter } from 'react-router-dom';
import shortid from 'shortid';
import FeatureBoxCSUnit from './FeaturedBoxUnit';
import { connect } from 'react-redux';

const featuredBox = (props) => {
  return (
    <div className="featuredBox case-studies-premium">
      <ul>
        {props.vendorCaseStudies.featured_reviews.map((freview, index) => (
          <FeatureBoxCSUnit
            {...freview}
            index={props.patterns[index]}
            key={shortid.generate()}
            pathname={props.location.pathname}
            isLeadGenPopUp={props.vendorProfile.is_lead_generate_popup}
            totalRefCount={
              props.vendorCommon.casestudy_count
                ? props.vendorCommon.casestudy_count +
                  props.vendorCommon.testimonial_count +
                  props.vendorCommon.video_count
                : 0
            }
            companyId={
              props.vendorCommon.company_id ? props.vendorCommon.company_id : -1
            }
            linkedInUrl={props.vendorCaseStudies.linkedin_signin_url}
          />
        ))}
      </ul>
    </div>
  );
};

const mapStateToProps = (state) => {
  return {
    vendorCommon: state.vendorCommon,
    vendorCaseStudies: state.vendorCaseStudies,
    vendorProfile: state.vendorProfile,
  };
};

const FBWithRouter = withRouter(featuredBox);
export default connect(mapStateToProps)(FBWithRouter);
